<template>
  <div :class="classnames">
    <popup @openchange="handlePopupOpenChange">
      <template slot="control">
        <div :class="`${ns}__hitzone`">
          <slot />
        </div>
      </template>

      <template slot="content">
        <div :class="`${ns}__view`">
          <ul :class="`${ns}__list`">
            <template v-for="(link, index) in trimmedLinks">
              <li :class="`${ns}__item`" :key="index">
                <template v-if="link.share">
                  <OpenModalControl  :view="'modal-view-share'" :props="link.share">
                    <span :class="`${ns}__link`">{{ link.text }}</span>
                  </OpenModalControl>
                </template>
                <template v-else>
                  <a :class="`${ns}__link`" :href="link.url" :target="setTarget(link)">{{ link.text }}</a>
                </template>
              </li>
            </template>
          </ul>
        </div>
      </template>
    </popup>
  </div>
</template>

<script>
  import OpenModalControl from '@/components/OpenModalControl'
  import Popup from '@/components/Popup/Popup'

  import { bem } from '@/mixins/bem.js'

  const namespace = 'additional-links-menu'

  // const isExternalLink = (url) => {
  //   return url.toLowerCase().indexOf('http') !== -1
  // }

  export default {
    name: 'AdditionalLinksMenu',
    components: {
      OpenModalControl,
      'popup': Popup
    },
    mixins: [ bem ],
    props: {
      above: {
        default: false,
        type: Boolean
      },
      links: {
        default: function () {
          return [
            {
              id: '0',
              text: 'Share',
              url: '#'
            },
            {
              id: '1',
              text: 'Edit in Shopify',
              url: '#'
            },
            {
              id: '2',
              text: 'View on Live Site',
              url: '#'
            }
          ]
        },
        type: Array
      }
    },
    data: function () {
      // limit number of links in list
      const trimmedLinks = this.links.slice(0, 3)

      return {
        isPopupOpen: false,
        trimmedLinks
      }
    },
    watch: {
      isPopupOpen: function (arr) {
        this.$emit('update-menu-focus-state', arr)
      }
    },
    created: function () {
      this.namespace = namespace
    },
    methods: {
      classnameModifiers: function () {
        const popupContentPosition = this.above ? 'above' : 'below'

        return [ popupContentPosition ]
      },
      handlePopupOpenChange: function (isPopupOpen) {
        this.isPopupOpen = isPopupOpen
      },
      setTarget: function (link) {
        const {
          target
        } = link

        const linkTarget = target || '_self'

        return linkTarget
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/AdditionalLinksMenu.vue